import { FC } from 'react';
import { observer } from 'mobx-react';
import FormCommon from '@/components/FormCommon';
import { BaseItem } from '@/components/FormItem';
import { $fm } from '@/Intl';
import { useProduct, useCallset } from '@/store';
import Transfer from './Transfer';

const getCallsetPropsByProduct = (product: Product = 'gxv3370') => {
  switch (product) {
    case 'gxv3350':
    case 'gxv3450':
      return {
        single: [
          { key: '9', title: $fm('CONFERENCE2') }, // 会议
          { key: '0', title: $fm('CALL_HOLD') }, // 保持
          { key: '5', title: $fm('CALL_VIDEO') }, // 视频
          { key: '4', title: $fm('RECORD') }, // 录音
          { key: '13', title: $fm('CALL_DETAIL') }, // 通话详情
          { key: '7', title: 'MPK' }, // MPK
        ],
        conf: [
          { key: '15', title: $fm('INVITE') }, // 邀请
          { key: '0', title: $fm('CALL_HOLD') }, // 保持
          { key: '4', title: $fm('RECORD') }, // 录音
          { key: '13', title: $fm('CALL_DETAIL') }, // 通话详情
          { key: '7', title: 'MPK' }, // MPK
        ],
        limit: 2,
      };
    case 'gxv3370':
    case 'gxv3380':
    case 'gxv3480':
      return {
        single: [
          { key: '9', title: $fm('CONFERENCE2') }, // 会议
          { key: '1', title: $fm('CALL_MUTE') }, // 静音
          { key: '2', title: $fm('CALL_KEYBOARD') }, // 键盘
          { key: '0', title: $fm('CALL_HOLD') }, // 保持
          { key: '5', title: $fm('CALL_VIDEO') }, // 视频
          { key: '4', title: $fm('RECORD') }, // 录音
          { key: '12', title: $fm('MEDIA_CHANNEL') }, // 媒体通路
          { key: '3', title: $fm('CALL_TRNF') }, // 转移
          { key: '13', title: $fm('CALL_DETAIL') }, // 通话详情
          { key: '14', title: $fm('NEW_CALL') }, // 新呼叫
          { key: '7', title: 'MPK' }, // MPK
        ],
        conf: [
          { key: '15', title: $fm('INVITE') }, // 邀请
          { key: '1', title: $fm('CALL_MUTE') }, // 静音
          { key: '2', title: $fm('CALL_KEYBOARD') }, // 键盘
          { key: '0', title: $fm('CALL_HOLD') }, // 保持
          { key: '4', title: $fm('RECORD') }, // 录音
          { key: '12', title: $fm('MEDIA_CHANNEL') }, // 媒体通路
          { key: '13', title: $fm('CALL_DETAIL') }, // 通话详情
          { key: '14', title: $fm('NEW_CALL') }, // 新呼叫
          { key: '7', title: 'MPK' }, // MPK
        ],
        limit: 4,
      };
    case 'gxv3470':
      return {
        single: [
          { key: '9', title: $fm('CONFERENCE2') }, // 会议
          { key: '1', title: $fm('CALL_MUTE') }, // 静音
          { key: '2', title: $fm('CALL_KEYBOARD') }, // 键盘
          { key: '0', title: $fm('CALL_HOLD') }, // 保持
          { key: '5', title: $fm('CALL_VIDEO') }, // 视频
          { key: '4', title: $fm('RECORD') }, // 录音
          { key: '12', title: $fm('MEDIA_CHANNEL') }, // 媒体通路
          { key: '3', title: $fm('CALL_TRNF') }, // 转移
          { key: '13', title: $fm('CALL_DETAIL') }, // 通话详情
          { key: '14', title: $fm('NEW_CALL') }, // 新呼叫
          { key: '7', title: 'MPK' }, // MPK
        ],
        conf: [
          { key: '15', title: $fm('INVITE') }, // 邀请
          { key: '1', title: $fm('CALL_MUTE') }, // 静音
          { key: '2', title: $fm('CALL_KEYBOARD') }, // 键盘
          { key: '0', title: $fm('CALL_HOLD') }, // 保持
          { key: '4', title: $fm('RECORD') }, // 录音
          { key: '12', title: $fm('MEDIA_CHANNEL') }, // 媒体通路
          { key: '13', title: $fm('CALL_DETAIL') }, // 通话详情
          { key: '14', title: $fm('NEW_CALL') }, // 新呼叫
          { key: '7', title: 'MPK' }, // MPK
        ],
        limit: 3,
      };

    case 'gac2570':
      return {
        single: [],
        conf: [
          { key: '15', title: $fm('INVITE') }, // 邀请
          { key: '1', title: $fm('CALL_MUTE') }, // 静音
          { key: '2', title: $fm('CALL_KEYBOARD') }, // 键盘
          // 缺成员管理 gac-todo
          { key: '0', title: $fm('CALL_HOLD') }, // 保持
          // 缺锁定 gac-todo
          { key: '13', title: $fm('CALL_DETAIL') }, // 通话详情
          { key: '7', title: 'MPK' }, // MPK
        ],
        limit: 4,
      };
  }
};

const CallSet: FC = () => {
  const [product] = useProduct();
  const [callset, updateCallset, defaults] = useCallset();
  const { single, conf, limit } = getCallsetPropsByProduct(
    product || 'gxv3370',
  );
  return (
    <FormCommon
      initialValues={callset}
      defaults={defaults}
      onUpdate={updateCallset}
    >
      {/* 单路 */}
      <BaseItem label={null} name='oneway'>
        <Transfer
          dataSource={single}
          title={$fm('ONEWAY_TITLE')}
          limit={limit}
          explain={<>{$fm('ONEWAY_PROMPT', { n: limit })}</>}
        />
      </BaseItem>
      <br />
      {/* 会议 */}
      <BaseItem label={null} name='conference'>
        <Transfer
          dataSource={conf}
          title={$fm('CON_TITLE')}
          limit={limit}
          explain={<>{$fm('CON_PROMPT', { n: limit })}</>}
        />
      </BaseItem>
    </FormCommon>
  );
};

export default observer(CallSet);
